import React, { useState } from "react";
import axios from "axios";
import "./BlogDashForm.css";

const BlogDashForm = () => {
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [summary, setSummary] = useState("");
  const [keywords, setKeywords] = useState("");
  const [content, setContent] = useState("");
  const [author, setAuthor] = useState("BuyTaxi");
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState(""); // קטגוריה
  const [seoTitle, setSeoTitle] = useState(""); // SEO Title
  const [seoDescription, setSeoDescription] = useState(""); // SEO Description
  const [altText, setAltText] = useState(""); // ALT Text לתמונה
  const [published, setPublished] = useState(true); // מצב פרסום

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !slug || !content) {
      alert("נא למלא את כל השדות החובה.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("slug", slug);
    formData.append("summary", summary);
    formData.append("keywords", keywords);
    formData.append("content", content);
    formData.append("author", author);
    formData.append("category", category);
    formData.append("seoTitle", seoTitle);
    formData.append("seoDescription", seoDescription);
    formData.append("altText", altText);
    formData.append("published", published ? "1" : "0");
    if (image) {
      formData.append("image", image);
    }

    try {
      const res = await axios.post("/api/taxiblogs", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("✅ מאמר הועלה בהצלחה!");
        // ניקוי הטופס
        setTitle("");
        setSlug("");
        setSummary("");
        setKeywords("");
        setContent("");
        setAuthor("BuyTaxi");
        setImage(null);
        setCategory("");
        setSeoTitle("");
        setSeoDescription("");
        setAltText("");
        setPublished(true);
      } else {
        alert("❌ שגיאה בהוספת מאמר");
      }
    } catch (error) {
      console.error("❌ שגיאה בשליחת טופס:", error);
      alert(`❌ שגיאה: ${error.message}`);
    }
  };

  return (
    <div className="BlogDashForm_container">
      <h1 className="BlogDashForm_h1">הוספת מאמר חדש</h1>
      <form className="BlogDashForm_form" onSubmit={handleSubmit} encType="multipart/form-data">

        <label className="BlogDashForm_label">כותרת:</label>
        <input
          className="BlogDashForm_input"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <label className="BlogDashForm_label">כתובת URL (Slug):</label>
        <input
          className="BlogDashForm_input"
          type="text"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          required
        />

        <label className="BlogDashForm_label">קטגוריה:</label>
        <select
          className="BlogDashForm_input"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">בחר קטגוריה</option>
          <option value="מדריכים">מדריכים</option>
          <option value="חדשות">חדשות</option>
          <option value="טיפים">טיפים</option>
        </select>

        <label className="BlogDashForm_label">תקציר:</label>
        <textarea
          className="BlogDashForm_textarea"
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
        />

        <label className="BlogDashForm_label">מילות מפתח:</label>
        <input
          className="BlogDashForm_input"
          type="text"
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
        />

        <label className="BlogDashForm_label">SEO Title:</label>
        <input
          className="BlogDashForm_input"
          type="text"
          value={seoTitle}
          onChange={(e) => setSeoTitle(e.target.value)}
        />

        <label className="BlogDashForm_label">SEO Description:</label>
        <textarea
          className="BlogDashForm_textarea"
          value={seoDescription}
          onChange={(e) => setSeoDescription(e.target.value)}
        />

        <label className="BlogDashForm_label">תוכן:</label>
        <textarea
          className="BlogDashForm_textarea"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        />

        <label className="BlogDashForm_label">תמונה:</label>
        <input
          className="BlogDashForm_input"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
        />

        <label className="BlogDashForm_label">טקסט ALT לתמונה:</label>
        <input
          className="BlogDashForm_input"
          type="text"
          value={altText}
          onChange={(e) => setAltText(e.target.value)}
        />

        <label className="BlogDashForm_label">מאמר מפורסם?</label>
        <select
          className="BlogDashForm_input"
          value={published ? "1" : "0"}
          onChange={(e) => setPublished(e.target.value === "1")}
        >
          <option value="1">כן</option>
          <option value="0">לא</option>
        </select>

        <button className="BlogDashForm_button" type="submit">
          שמירת מאמר
        </button>
      </form>
    </div>
  );
};

export default BlogDashForm;
